module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zb-box"
  }, [_c('div', {
    staticClass: "zb-box-left"
  }, [_c('tengxunyunzb', {
    ref: "txyzb"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right"
  }, [_c('div', {
    staticClass: "zb-box-right-top"
  }, [_c('div', {
    staticClass: "zb-box-right-name"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianbiaoti')))]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.geinidezhibojianqugemingziba')
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-name"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianbeijing')))]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-bj"
  }, [(!_vm.form.backgroundUrl) ? _c('img', {
    staticClass: "zb-box-right-bj-img",
    attrs: {
      "src": require("../../../assets/image/tianjia_tupian@2x.png"),
      "alt": "添加图片"
    },
    on: {
      "click": _vm.handleUploadClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.backgroundUrl) ? _c('img', {
    staticClass: "zb-box-right-bj-img",
    attrs: {
      "src": _vm.form.backgroundUrl,
      "alt": ""
    },
    on: {
      "click": _vm.handleUploadClick
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-name"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianbiaoqian')))]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-bq"
  }, _vm._l((_vm.bqList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.bqListIndex === index ? 'zb-box-right-bq-item' : 'zb-box-right-bq-item1',
      on: {
        "click": function($event) {
          return _vm.handleBq(index)
        }
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-name"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianhuazhi')))]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-bq"
  }, _vm._l((_vm.hzList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.hzListIndex === index ? 'zb-box-right-bq-item' : 'zb-box-right-bq-item1',
      on: {
        "click": function($event) {
          return _vm.handleHz(index)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.startKey),
      expression: "form.startKey"
    }],
    attrs: {
      "placeholder": _vm.$t('all.qingshurukaibomiyao'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.startKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "startKey", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zb-box-right-bottom-btn",
    on: {
      "click": _vm.startLive
    }
  }, [_vm._v(_vm._s(_vm.$t('all.kaishizhibo')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6da9224c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/zhibo/zhibo.vue
// module id = 821
// module chunks = 1